function roundRect(ctx, x, y, w, h, r) {
  ctx.beginPath();
  ctx.moveTo(x + r, y);
  ctx.arcTo(x + w, y, x + w, y + h, r);
  ctx.arcTo(x + w, y + h, x, y + h, r);
  ctx.arcTo(x, y + h, x, y, r);
  ctx.arcTo(x, y, x + w, y, r);
  ctx.closePath();
}

export const ShareCardService = {
  /** Renders a shareable PNG card for an unlocked badge. */
  generateBadgeCard(badge, badgeTitle) {
    const canvas = document.createElement('canvas');
    canvas.width = 800;
    canvas.height = 800;
    const ctx = canvas.getContext('2d');

    const bg = ctx.createLinearGradient(0, 0, 800, 800);
    bg.addColorStop(0, '#4F46E5');
    bg.addColorStop(1, '#7C3AED');
    ctx.fillStyle = bg;
    ctx.fillRect(0, 0, 800, 800);

    ctx.fillStyle = '#ffffff';
    roundRect(ctx, 80, 160, 640, 480, 32);
    ctx.fill();

    ctx.textAlign = 'center';
    ctx.font = '140px sans-serif';
    ctx.fillText(badge.emoji || '🏆', 400, 370);

    ctx.fillStyle = '#6366F1';
    ctx.font = 'bold 22px sans-serif';
    ctx.fillText('BADGE UNLOCKED', 400, 440);

    ctx.fillStyle = '#0F172A';
    ctx.font = 'bold 40px sans-serif';
    ctx.fillText(badgeTitle, 400, 500, 560);

    ctx.fillStyle = '#ffffff';
    ctx.font = 'bold 30px sans-serif';
    ctx.fillText('SublingoX', 400, 720);

    return new Promise((resolve) => canvas.toBlob(resolve, 'image/png'));
  },

  /** Shares the image via the Web Share API when available (mobile browsers), otherwise downloads it. */
  async shareOrDownload(blob, filename, shareText) {
    if (!blob) return false;
    if (navigator.share && navigator.canShare) {
      const file = new File([blob], filename, { type: 'image/png' });
      if (navigator.canShare({ files: [file] })) {
        try {
          await navigator.share({ files: [file], text: shareText });
          return true;
        } catch {
          return false; // user cancelled the share sheet
        }
      }
    }
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(url);
    return true;
  },
};
